module.exports = __webpack_public_path__ + "static/banner-871868b522ccc75b8d2203ba6284e28e.jpg";